import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ListItem, Typography } from '@sm/wds-react';

const titleClassname = classNames(
  'sm-mobile-menu__type-title',
  'sm-mobile-menu-anon--no-subtitle'
);

export const SolutionByNeed = ({ title, url, openInNewWindow }) => {
  return (
    <ListItem
      key={title}
      isNavigable
      navigationTarget={url}
      className="sm-mobile-menu__nested-item"
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      <Typography
        variant="sectionTitle"
        color="link"
        className={titleClassname}
      >
        {title}
      </Typography>
    </ListItem>
  );
};

export default SolutionByNeed;

SolutionByNeed.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openInNewWindow: PropTypes.bool,
};

SolutionByNeed.defaultProps = {
  openInNewWindow: false,
};
